import React, { useState, useEffect, useContext } from 'react'
import { AppStoreContext } from '../../context/appStoreContext';
import Loader from '../../components/Loader';
//styles
import { Container, Main } from '../MailRoom/styles';
import {
  GeneratedDocumentsHeadSection,
  TemplateTitle,
  DocumentMetrics,
  Filters,
  ClearDataButton,
  SearchButton,
  DocumentTable,
  GeneratedDocumentsWrapper,
} from './style';
// apis
import {
  getTemplatesName,
  fetchFiles,
  deleteFiles,
  getGroupPermissionForUsers,
  getStorageSpace,
} from '../../utils/services/generatedDocumentsAPI';
import { getGroupPermission } from '../../utils/services/teamsAPI';
//ant design 
import { Table, message, Checkbox, Select, Icon, Space } from 'antd';
import { DateTimePicker } from 'react-rainbow-components';
import moment from 'moment';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
// localization imports
import { withTranslation } from 'react-i18next';
import { GENERATED_DOCUMENTS_PAGE, CONFIRMATION_MODAL } from './translationValues';
import { ScrollContainer } from '../LandingPage/styles';

import { DEFAULT_DATE_TIME_FORMAT } from '../../utils/helper';

const NAMESPACES = ['GENERATED_DOCUMENTS_PAGE', 'CONFIRMATION_MODAL'];
const CONFIRM = 'CONFIRMATION_MODAL';
const RECORDS_PER_PAGE = 10;
const FIRST_PAGE = 1;

function GeneratedDocuments(props) {
  const defaultCheckedList = [];
  const [storageLimit, setStorageLimit] = useState(0);
  const [usedStorage, setUsedStorage] = useState(0);
  const [generatedFiles, setGeneratedFiles] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0); // count of all the documents created, not just filtered out in search
  const [totalSearchedRecords, setTotalSearchedRecords] = useState(0); // count of all documents that is searched
  const [currentPage, setCurrentPage] = useState(FIRST_PAGE);
  const [pagination, setPagination] = useState({ pageSize: RECORDS_PER_PAGE });
  const [pageChanged, setPageChanged] = useState(false)
  const [environment, setEnvironment] = useState('');
  //---------teams
  const [teamsList, setTeamsList] = useState([]); // sets all the teams list for the user
  const [selectedTeams, setSelectedTeams] = useState([]); // set selected teams from the multi selector
  const [selectedTeamsName, setSelectedTeamsName] = useState([]); // set selected teams name from the multi selector
  const [filteredTeams, setFilteredTeams] = useState([]); // set non-selected teams from the multi selector
  //-----------templstes
  const [templatesNameList, setTemplatesNameList] = useState({}); // sets all the templates listed
  const [updatedTemplatesNameList, setupdatedTemplatesNameList] = useState([]); // sets all the templates listed when a team is selected
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [selectedTemplatesName, setSelectedTemplatesName] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [startAndEndDate, setStartAndEndDate] = useState({
    startDate: null,
    startDateString: '',
    endDate: null,
    endDateString: '',
    endOpen: false,
  }); // these are the state of start and end date in the filter
  const [disabledDate, setDisabledDate] = useState({
    fromDisabledMinDate: new Date('2023-01-01 00:00:00'),
    fromDisabledMaxDate: new Date(), //changes if tillDate is selected
    tillDisabledMinDate: new Date('2023-09-03 00:00:00'), //changes if fromDate is selected
    tillDisabledMaxDate: new Date(),
  }); // these are disabled dates for the date time picker in the filter, time is also handled along side
  const [visible, setVisible] = useState(false); // control visibility of modal
  const [isLoading, setIsLoading] = useState(false); // control state of loader for the modal
  const [tableLoader, setTableLoader] = useState(false);
  const [isSingleDocumentDeletion, setIsSingleDocumentDeletion] = useState([]); // Store the unique ID that is attached to that document object( not the same as templateId ) in case of single document deletion
  const [selectedDocuments, setSelectedDocuments] = useState({
    checkedListLength: defaultCheckedList,
    indeterminate: false,
    checkAll: false,
  }); // these are documents selected by the select all checkbox
  const [onMountActionsController, setOnMountActionController] = useState(true); // a state to control ui while rendering for the very first time
  const [selectedCheckedListLength, setSelectedCheckedListLength] = useState(0); // a state show the count for selected docs
  const [fetchParameterDataObj, setFetchParameterDataObj] = useState({
    limit: RECORDS_PER_PAGE,
    page: currentPage,
  });
  const [fetchParameterDataObjController, setFetchParameterDataObjController] = useState(true);

  const [channel, setChannel] = useState([]);
  const [fileType, setFileType] = useState([]);

  const { userDetails } = useContext(AppStoreContext); // user role is determined
  const { Column } = Table;
  const { Option } = Select;
  const { t } = props;

  // Fetch storage, teams, templates and documents in the initial render
  useEffect(() => {
    setOnMountActionController(false);
    fetchStorageSpace();
    fetchTotalGeneratedDocuments();
    fetchTeamsList();
    fetchTemplatesName();
  }, []);

  // Fetch and repopulated the listed documents in the ui on change of table page
  useEffect(() => {
    fetchGeneratedDocumentsOnSearch();
  }, [currentPage]);

  //Filtered teams is the list of teams visible in the drop down while trying to filter
  //teamlist is the array of team objects used to populated filtered teams initially
  useEffect(() => {
    setFilteredTeams(teamsList);
  }, [teamsList]);

  //Filtered templates is the list of templates visible in the drop down while trying to filter templates
  //templatesnamelist is an object with array of template objects mapped to team ids, that is
  //templates that are accessible by users of a team are mapped to those team
  useEffect(() => {
    selectedTeamsName.length === 0 &&
      templatesNameList[null] &&
      setFilteredTemplates(templatesNameList[null]);
  }, [templatesNameList]);

  // selected teams name (an array of names) is different from selected teams ( an array of resource group numbers)
  useEffect(() => {
    teamsList &&
      teamsList.map(teamObj => {
        selectedTeamsName.includes(teamObj.name) &&
          setSelectedTeams(prev => [...prev, teamObj.rgId]);
      });
  }, [selectedTeamsName]);

  // on filtering the teams, the templates that need to be render change, in case not teams is selected - all templates are listed
  useEffect(() => {
    const updatedTemplateList = [];
    selectedTeams.map(teamId => {
      templatesNameList[teamId]
        ? updatedTemplateList.push(...templatesNameList[teamId])
        : console.log('');//template list is not updated
    });
    setupdatedTemplatesNameList(updatedTemplateList);
    setSelectedTemplatesName([]);
    setSelectedTemplates([]);
  }, [selectedTeams]);

  //updated templates name list is an array of templates name that is populated and repopulated when ever a change in teams in handled
  useEffect(() => {
    selectedTeams.length > 0 && setFilteredTemplates(updatedTemplatesNameList);
  }, [updatedTemplatesNameList]);

  useEffect(() => {
    selectedTeamsName.length === 0 &&
      selectedTemplatesName.length === 0 &&
      templatesNameList[null] &&
      setFilteredTemplates(templatesNameList[null]);
    const selectedTemplateArr = [];
    for (const key in templatesNameList) {
      templatesNameList &&
        templatesNameList[key].map(templateObj => {
          selectedTemplatesName.includes(templateObj.name) &&
            selectedTemplateArr.push(templateObj.id);
        });
    }
    const selectedTemplateArrWithUniqueValues = selectedTemplateArr.filter(
      (value, index, self) => self.indexOf(value) === index,
    );
    setSelectedTemplates(selectedTemplateArrWithUniqueValues);
  }, [selectedTemplatesName]);

  useEffect(() => {
    if (fetchParameterDataObjController) {
      fetchGeneratedDocumentsOnSearch();
    }
  }, [fetchParameterDataObjController]);

  //Select all documents for deletion
  const onSelectAll = e => {
    setSelectedDocuments({
      checkedListLength: e.target.checked ? selectedCheckedListLength : defaultCheckedList.length,
      indeterminate: false,
      checkAll: e.target.checked,
    });
  };

  const checkUserRole = () => {
    return userDetails.roles.includes('ADMIN');
  };

  //On selecting an environment filter option
  const handleEnvironment = env => {
    setEnvironment(env);
  };

  //Fetch list of all published template namess
  const fetchStorageSpace = async () => {
    try {
      const response = await getStorageSpace();
      if (response) {
        const usedStorage = parseFloat(parseFloat(response?.data?.usedStorage).toFixed(1));
        setUsedStorage(usedStorage);
        const storageLimit = Number(response?.data?.storageLimit);
        setStorageLimit(storageLimit);
      }
    } catch (e) {
      console.log('error ==>', e);
    }
  };
  
  //Fetch list of teams
  const fetchTeamsList = async () => {
    // Check user role
    const isAdmin = checkUserRole();
    // If user is not admin, then get the rgroupIds for which the user has write access
    if (!isAdmin) {
      let teamsArr = [];
      //Get list of teams the user is a part of
      const teamsList = await getGroupPermissionForUsers();
      if (teamsList && teamsList?.data != null) {
        teamsList.data.map((team, index) => {
          const isPresent = teamsArr.some(data => data.rgId === team.rgId);
          if (team.permission === 'write' && !isPresent) {
            const teamsObj = {
              id: team.id,
              rgId: team.rgId,
              name: team.groupName,
            };
            teamsArr.push(teamsObj);
          }
        });
        setTeamsList(teamsArr);
      }
    } else {
      //Get list of teams the user is a part of
      const teamsList = await getGroupPermission();
      // If user is admin, list all unique teams from the response
      let teamsArr = [];
      teamsList && teamsList.data.map((team, index) => {
        const isPresent = teamsArr.some(data => data.rgId === team.rgId);
        if (!isPresent) {
          const teamsObj = {
            id: team.id,
            rgId: team.rgId,
            name: team.groupName,
          };
          teamsArr.push(teamsObj);
        }
      });
      setTeamsList(teamsArr);
    }
  };
  //On selecting a team filter option
  const handleSelectedTeams = selectedTeamsNameArr => {
    setupdatedTemplatesNameList([]);
    setSelectedTeams([]);
    const allTeamsName = teamsList.length > 0 && teamsList.map(team => team.name);
    selectedTeamsNameArr.includes('selectAllTeams')
      ? setSelectedTeamsName(allTeamsName)
      : setSelectedTeamsName(selectedTeamsNameArr);
    selectedTeamsNameArr.includes('selectAllTeams')
      ? setFilteredTeams([])
      : setFilteredTeams(teamsList.filter(team => !selectedTeamsNameArr.includes(team.name)));
  };

  //Fetch list of all published template namess
  const fetchTemplatesName = async () => {
    try {
      const response = await getTemplatesName();
      if (response) {
        const templatesList = response?.data.reduce((templateObj, template) => {
          const { id, name, resourceGroup } = template;
          if (!templateObj[resourceGroup]) {
            templateObj[resourceGroup] = [];
          }
          templateObj[resourceGroup].push({ id, name, resourceGroup });
          return templateObj;
        }, {});
        const allTemplatesList = response?.data.map(template => template);
        templatesList.null = allTemplatesList;
        setTemplatesNameList(templatesList);
      }
    } catch (e) {
      console.log('error', e);
    }
  };

  //On selecting a template filter option
  const handleSelectedTemplates = selectedTemplatesNameArr => {
    if (selectedTeamsName.length > 0) {
      const allTemplatesName =
        updatedTemplatesNameList.length > 0 &&
        updatedTemplatesNameList.map(template => template.name);
      selectedTemplatesNameArr.includes('selectAllTemplates')
        ? setSelectedTemplatesName(allTemplatesName)
        : setSelectedTemplatesName(selectedTemplatesNameArr);
      selectedTemplatesNameArr.includes('selectAllTemplates')
        ? setFilteredTemplates([])
        : setFilteredTemplates(
          updatedTemplatesNameList.filter(
            template => !selectedTemplatesNameArr.includes(template.name),
          ),
        );
    } else {
      const allTemplatesName =
        templatesNameList[null].length > 0 &&
        templatesNameList[null].map(template => template.name);
      selectedTemplatesNameArr.includes('selectAllTemplates')
        ? setSelectedTemplatesName(allTemplatesName)
        : setSelectedTemplatesName(selectedTemplatesNameArr);
      selectedTemplatesNameArr.includes('selectAllTemplates')
        ? setFilteredTemplates([])
        : setFilteredTemplates(
          templatesNameList[null].filter(
            template => !selectedTemplatesNameArr.includes(template.name),
          ),
        );
    }
    setSelectedTemplates([]);
  };

  // Calling api to fetch generated documents data and set clean values for the initial render
  const fetchTotalGeneratedDocuments = async () => {
    try {
      const data = {};
      data.limit = RECORDS_PER_PAGE;
      data.page = FIRST_PAGE;
      if (fileType.length !== file_Type.length) {
        data.fileType = fileType[0];
      }
      let response = await fetchFiles(data);
      if(response){
        setTotalRecords(response?.dataCount);
        setPagination({ ...pagination, total: response?.dataCount });
        setGeneratedFiles(response?.data);
      }
    } catch (e) {
      console.log('error', e);
    }
  };

  //Calling api to fetch generated documents
  const fetchGeneratedDocumentsOnSearch = async () => {
    setTableLoader(true);
    pageChanged
      ? setSelectedDocuments(prev => prev) // if page is changed, the selected documents will persist
      : setSelectedDocuments(prev => ({ ...prev, checkedListLength: 0, checkAll: false })); // if select all is selected while a new search is executed, it will uncheck the box

    //Get comma seperated teamIds from array of team objects
    const commaSeperatedTeamIds = selectedTeamsName.length === 0 ? '' : selectedTeams.join(',');

    //Get comma seperated templateIds from array of team objects
    const commaSeperatedTemplateIds = selectedTemplates.length === 0 ? '' : selectedTemplates.join(',');
    
    const data = { ...fetchParameterDataObj };
    pageChanged && (data.page = currentPage);
    if (fetchParameterDataObjController) {
      setCurrentPage(FIRST_PAGE)
      setPagination(prev => ({ ...prev, current: FIRST_PAGE }));
      data.page = FIRST_PAGE;
      environment
        ? (data.environment = environment)
        : (data.environment = null); // Check if any environment is selected
      selectedTeams.length > 0
        ? (data.teamIds = commaSeperatedTeamIds)
        : (data.teamIds = null); // Check if any team is selected
      selectedTemplates.length > 0
        ? (data.templateIds = commaSeperatedTemplateIds)
        : (data.templateIds = null); // Check if any templateId is selected

      // Check if start and end date is selected
      if (startAndEndDate && startAndEndDate.startDate && startAndEndDate.endDate) {
        data.fromDate = startAndEndDate.startDate;
        data.toDate = startAndEndDate.endDate;
      } else if (!startAndEndDate.startDate || !startAndEndDate.endDate) {
        data.fromDate = null;
        data.toDate = null;
      }
      if (channel && (channel.length !== channelType.length)) {
        data.channel = channel[0];
      }
      if (fileType && (fileType.length !== file_Type.length)) {
        data.fileType = fileType[0];
      }
    }
    setFetchParameterDataObjController(false);
    setFetchParameterDataObj(data);
    // conditionally call the api considering all filters
    let response;
    if (
      (environment || selectedTeams.length > 0 || selectedTemplates.length > 0) &&
      startAndEndDate &&
      startAndEndDate.startDate &&
      !startAndEndDate.endDate
    ) {
      message.error(
        t(
          GENERATED_DOCUMENTS_PAGE.GENERATED_TILL_DATE_NOT_SELECTED_ERROR_MESSAGE.key,
          GENERATED_DOCUMENTS_PAGE.GENERATED_TILL_DATE_NOT_SELECTED_ERROR_MESSAGE.value,
        )
      );
    } else if (
      !environment &&
      selectedTeams.length === 0 &&
      selectedTemplates.length === 0 &&
      startAndEndDate &&
      startAndEndDate.startDate &&
      !startAndEndDate.endDate
    ) {
      message.error(
        t(
          GENERATED_DOCUMENTS_PAGE.GENERATED_TILL_DATE_NOT_SELECTED_ERROR_MESSAGE.key,
          GENERATED_DOCUMENTS_PAGE.GENERATED_TILL_DATE_NOT_SELECTED_ERROR_MESSAGE.value,
        ),
      );
    } else if (
      environment ||
      selectedTeams.length > 0 ||
      selectedTemplates.length > 0 ||
      (startAndEndDate && !startAndEndDate.startDate && !startAndEndDate.endDate)
    ) {
      response = await fetchFiles(data);
      handleFetchGeneratedDocumentsOnSearchSetters(response);
    } else if (
      environment ||
      selectedTeams.length > 0 ||
      selectedTemplates.length > 0 ||
      (startAndEndDate && startAndEndDate.startDate && startAndEndDate.endDate)
    ) {
      response = await fetchFiles(data);
      handleFetchGeneratedDocumentsOnSearchSetters(response);
    }
    setTableLoader(false);
  };

  // nested function to handles all setters on a successful execution of the fetchGeneratedDocumentsOnSearch function
  const handleFetchGeneratedDocumentsOnSearchSetters = response => {
    //Setting total no. of records
    onMountActionsController
      ? setTotalSearchedRecords(response.dataCount)
      : pageChanged
        ? setTotalSearchedRecords(prev => prev)
        : setTotalSearchedRecords(response.dataCount || 0);

    // taking adantage of this state to revert the total searched records count to 0,
    // visible is true only when delete action is triggered, be it for a single doc or multiple
    // visible && setTotalSearchedRecords(0);

    setSelectedCheckedListLength(response.dataCount || 0);

    // setting the total number of documents for table pagination
    setPagination(prev => ({
      ...prev,
      total: response.dataCount,
    }));
    setPageChanged(false)
    //population the table with documents data
    setGeneratedFiles(response.data);
  };

  //Delete the selected files
  const deleteDocuments = async () => {
    setIsLoading(true);
    let data = {};
    if (isSingleDocumentDeletion.length === 1) {
      data = { ids: isSingleDocumentDeletion.join(',') }
    } else {
      data = { ...fetchParameterDataObj };
    }
    const response = await deleteFiles(data);
    //Display message from API response
    if (response.statusCode === 2205) {
      message.success(t(
        GENERATED_DOCUMENTS_PAGE.GENERATED_FILE_DELETED_SUCCESS.key,
        GENERATED_DOCUMENTS_PAGE.GENERATED_FILE_DELETED_SUCCESS.value,
      ));
    } else {
      message.error(
        t(
          GENERATED_DOCUMENTS_PAGE.GENERATED_FILE_DELETED_FAILURE.key,
          GENERATED_DOCUMENTS_PAGE.GENERATED_FILE_DELETED_FAILURE.value,
        ),
      );
    }
    setSelectedCheckedListLength(0);
    setIsSingleDocumentDeletion([]);
    setIsLoading(false);
    setVisible(false);
    fetchTotalGeneratedDocuments(); // calling here again while delteing files to update the value of total records count
    fetchGeneratedDocumentsOnSearch();// calling here again while deleting files to update the list of files rendered in the ui
    fetchStorageSpace();
  };

  //Check if a single document deletion or multiple document deletion is triggered
  const openConfirmationModal = e => {
    if (e.target.className === 'delete-btn') {
      setIsSingleDocumentDeletion([e.target.id]);
    } else if (e.target.className === 'delete_selected-button') {
      setIsSingleDocumentDeletion([]);
    }
    setVisible(true);
  };

  //clear the selected date
  const clearDate = () => {
    setStartAndEndDate(prev => ({
      ...prev,
      startDate: null,
      startDateString: '',
      endDate: null,
      endDateString: '',
      endOpen: null,
    }));
    setDisabledDate(prev => ({
      ...prev,
      fromDisabledMinDate: new Date('2023-01-01 00:00:00'),
      fromDisabledMaxDate: new Date(), //changes if tillDate is selected
      tillDisabledMinDate: new Date('2023-09-03 00:00:00'), //changes if fromDate is selected
      tillDisabledMaxDate: new Date(),
    }));
  };

  //clear all the filter
  const clearAllFilters = async() => {
    setEnvironment('');
    setSelectedTeams([]);
    setSelectedTeamsName([]);
    setSelectedTemplates([]);
    setSelectedTemplatesName([]);
    setChannel([]);
    setFileType([])
    setStartAndEndDate(prev => ({
      ...prev,
      startDate: null,
      startDateString: '',
      endDate: null,
      endDateString: '',
      endOpen: null,
    }));
    setDisabledDate(prev => ({
      ...prev,
      fromDisabledMinDate: new Date('2023-01-01 00:00:00'),
      fromDisabledMaxDate: new Date(), //changes if tillDate is selected
      tillDisabledMinDate: new Date('2023-09-03 00:00:00'), //changes if fromDate is selected
      tillDisabledMaxDate: new Date(),
    }));
    const payload = { limit: 10, page: 1 };
    const response = await fetchFiles(payload);
    handleFetchGeneratedDocumentsOnSearchSetters(response);
  };

  //handle genarated from date time picker
  const handleFromDateTimePicker = value => {
    setDisabledDate(prev => ({
      ...prev,
      tillDisabledMinDate: new Date(moment(value).format(DEFAULT_DATE_TIME_FORMAT)),
    }));
    if (
      startAndEndDate.endDate &&
      startAndEndDate.endDate > moment(value).format(DEFAULT_DATE_TIME_FORMAT)
    ) {
      setStartAndEndDate(prevState => ({
        ...prevState,
        startDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
      }));
    } else if (
      startAndEndDate.endDate &&
      startAndEndDate.endDate <= moment(value).format(DEFAULT_DATE_TIME_FORMAT)
    ) {
      message.error(
        t(
          GENERATED_DOCUMENTS_PAGE.WRONG_GENERATED_FROM_DATE_ERROR_MESSAGE.key,
          GENERATED_DOCUMENTS_PAGE.WRONG_GENERATED_FROM_DATE_ERROR_MESSAGE.value,
        ),
        4.7,
      );
    } else {
      setStartAndEndDate(prevState => ({
        ...prevState,
        startDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
      }));
    }
  };
  //handle genarated till date time picker
  const handleTillDateTimePicker = value => {
    setDisabledDate(prev => ({
      ...prev,
      fromDisabledMaxDate: new Date(moment(value).format(DEFAULT_DATE_TIME_FORMAT)),
    }));
    if (
      startAndEndDate.startDate &&
      startAndEndDate.startDate < moment(value).format(DEFAULT_DATE_TIME_FORMAT)
    ) {
      setStartAndEndDate(prevState => ({
        ...prevState,
        endDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
      }));
    } else if (
      startAndEndDate.startDate &&
      startAndEndDate.startDate >= moment(value).format(DEFAULT_DATE_TIME_FORMAT)
    ) {
      message.error(
        t(
          GENERATED_DOCUMENTS_PAGE.WRONG_GENERATED_TILL_DATE_ERROR_MESSAGE.key,
          GENERATED_DOCUMENTS_PAGE.WRONG_GENERATED_TILL_DATE_ERROR_MESSAGE.value,
        ),
        4.7,
      );
    } else {
      setStartAndEndDate(prevState => ({
        ...prevState,
        endDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
      }));
    }
  };

  const channelType = [{ id: '1', name: "email", displayName: "Email" }, { id: '2', name: "print", displayName: "Print" }];
  const file_Type = [{ id: '1', name: "HTML" }, { id: '2', name: "PDF" }];


  return (
    <>
      <GeneratedDocumentsWrapper>
        <Main>
          <Container>
            <ScrollContainer>
              {/* Head */}
              <GeneratedDocumentsHeadSection>
                <TemplateTitle>
                  <p className={'template_title'}>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.GENERATED_DOCUMENTS_TITLE.key,
                      GENERATED_DOCUMENTS_PAGE.GENERATED_DOCUMENTS_TITLE.value,
                    )}
                  </p>
                  <p className={'template_desc'}>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.GENERATED_DOCUMENTS_DESCRIPTION.key,
                      GENERATED_DOCUMENTS_PAGE.GENERATED_DOCUMENTS_DESCRIPTION.value,
                    ).toUpperCase()}
                  </p>
                </TemplateTitle>
                <DocumentMetrics>
                  <div className="metrics-container">
                    <span className="mertics-heading">
                      {t(
                        GENERATED_DOCUMENTS_PAGE.USED_STORAGE_SPACE_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.USED_STORAGE_SPACE_TITLE.value,
                      ).toUpperCase()}
                    </span>
                    <span className="metrics-value">
                      <>
                        <strong>{`${usedStorage}GB`}</strong>
                        {' ' +
                          t(
                            GENERATED_DOCUMENTS_PAGE.USED_STORAGE_SPACE_VALUE_LABEL.key,
                            GENERATED_DOCUMENTS_PAGE.USED_STORAGE_SPACE_VALUE_LABEL.value,
                          ).toUpperCase() +
                          ' '}
                        <strong>{`${storageLimit}GB`}</strong>
                      </>
                    </span>
                  </div>
                  <div className="metrics-container">
                    <span className="mertics-heading">
                      {t(
                        GENERATED_DOCUMENTS_PAGE.DOCUMENTS_IN_STORAGE_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.DOCUMENTS_IN_STORAGE_TITLE.value,
                      ).toUpperCase()}
                    </span>
                    <span className="metrics-value">
                      <strong>{totalRecords}</strong>
                    </span>
                  </div>
                </DocumentMetrics>
              </GeneratedDocumentsHeadSection>
              {/* Filters */}
              <Filters>
                <div className="environment-container">
                  <label>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_LABEL.key,
                      GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_LABEL.value,
                    )}
                  </label>
                  <Select
                    placeholder={t(
                      GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_PLACEHOLDER.key,
                      GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_PLACEHOLDER.value,
                    )}
                    style={{ width: '100%' }}
                    onChange={handleEnvironment}
                    allowClear={true}
                    value={environment === '' ? undefined : environment}
                  >
                    <Option value="sandbox">
                      {t(
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_TESTING_OPTION.key,
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_TESTING_OPTION.value,
                      )}
                    </Option>
                    <Option value="live">
                      {t(
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_PUBLISHED_OPTION.key,
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_PUBLISHED_OPTION.value,
                      )}
                    </Option>
                    <Option value={null}>
                      {t(
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_BOTH_OPTION.key,
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_FILTER_BOTH_OPTION.value,
                      )}
                    </Option>
                  </Select>
                </div>
                <div className="team-name-container">
                  <label>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.TEAM_NAMES_LABEL.key,
                      GENERATED_DOCUMENTS_PAGE.TEAM_NAMES_LABEL.value,
                    )}
                  </label>
                  <Select
                    mode="multiple"
                    showArrow
                    allowClear
                    style={{
                      width: '100%',
                    }}
                    placeholder={t(
                      GENERATED_DOCUMENTS_PAGE.TEAM_NAMES_PLACEHOLDER.key,
                      GENERATED_DOCUMENTS_PAGE.TEAM_NAMES_PLACEHOLDER.value,
                    )}
                    value={selectedTeamsName}
                    onChange={handleSelectedTeams}
                  >
                    <Option
                      key="selectAllTeams"
                      value="selectAllTeams"
                      disabled={filteredTeams.length === 0 ? true : false}
                    >
                      {t(
                        GENERATED_DOCUMENTS_PAGE.SELECT_ALL_TEAMS_LABEL.key,
                        GENERATED_DOCUMENTS_PAGE.SELECT_ALL_TEAMS_LABEL.value,
                      )}
                    </Option>
                    {filteredTeams.map((team, index) => (
                      <Option key={team.rgId} value={team.name}>
                        {team.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="template-name-container">
                  <label>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.CHANNEL_TYPE_LABEL.key,
                      GENERATED_DOCUMENTS_PAGE.CHANNEL_TYPE_LABEL.value,
                    )}
                  </label>
                  <Select
                    mode="multiple"
                    showArrow
                    allowClear
                    style={{
                      width: '100%',
                    }}
                    placeholder={t(
                      GENERATED_DOCUMENTS_PAGE.CHANNEL_TYPE_PLACEHOLDER.key,
                      GENERATED_DOCUMENTS_PAGE.CHANNEL_TYPE_PLACEHOLDER.value,
                    )}
                    value={channel}
                    onChange={(e) => { setChannel([...e]) }}
                  >

                    {channelType.map((item, index) => (
                      <Option key={item.id} value={item.name}>
                        {item.displayName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="template-name-container">
                  <label>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.FILE_TYPE_LABEL.key,
                      GENERATED_DOCUMENTS_PAGE.FILE_TYPE_LABEL.value,
                    )}
                  </label>
                  <Select
                    mode="multiple"
                    showArrow
                    allowClear
                    style={{
                      width: '100%',
                    }}
                    placeholder={t(
                      GENERATED_DOCUMENTS_PAGE.FILE_TYPE_PLACEHOLDER.key,
                      GENERATED_DOCUMENTS_PAGE.FILE_TYPE_PLACEHOLDER.value,
                    )}
                    value={fileType}
                    onChange={(e) => { setFileType([...e]) }}
                  >
                    {file_Type.map((item, index) => (
                      <Option key={item.id} value={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="template-name-container">
                  <label>
                    {t(
                      GENERATED_DOCUMENTS_PAGE.TEMPLATE_NAMES_LABEL.key,
                      GENERATED_DOCUMENTS_PAGE.TEMPLATE_NAMES_LABEL.value,
                    )}
                  </label>
                  <Select
                    mode="multiple"
                    showArrow
                    allowClear
                    style={{
                      width: '100%',
                    }}
                    placeholder={t(
                      GENERATED_DOCUMENTS_PAGE.TEMPLATE_NAMES_PLACEHOLDER.key,
                      GENERATED_DOCUMENTS_PAGE.TEMPLATE_NAMES_PLACEHOLDER.value,
                    )}
                    value={selectedTemplatesName}
                    onChange={handleSelectedTemplates}
                  >
                    <Option
                      key="selectAllTemplates"
                      value="selectAllTemplates"
                      disabled={filteredTemplates.length === 0 ? true : false}
                    >
                      {t(
                        GENERATED_DOCUMENTS_PAGE.SELECT_ALL_TEMPLATES_LABEL.key,
                        GENERATED_DOCUMENTS_PAGE.SELECT_ALL_TEMPLATES_LABEL.value,
                      )}
                    </Option>
                    {filteredTemplates.map((template, index) => (
                      <Option key={template.id} value={template.name}>
                        {template.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="date-time-picker-container">
                  <DateTimePicker
                    id="generatedFromDate"
                    className="dateTimePicker"
                    formatStyle="large"
                    size="small"
                    label={t(
                      GENERATED_DOCUMENTS_PAGE.FROM_DATE_LABEL.key,
                      GENERATED_DOCUMENTS_PAGE.FROM_DATE_LABEL.value,
                    )}
                    placeholder={t(
                      GENERATED_DOCUMENTS_PAGE.FROM_DATE_PLACEHOLDER.key,
                      GENERATED_DOCUMENTS_PAGE.FROM_DATE_PLACEHOLDER.value,
                    )}
                    minDate={disabledDate.fromDisabledMinDate}
                    maxDate={disabledDate.fromDisabledMaxDate} //set the max date based on generated till date
                    onChange={handleFromDateTimePicker}
                    hour24
                    value={startAndEndDate.startDate}
                  />
                  {startAndEndDate.startDate && (
                    <DateTimePicker
                      id="generatedTillDate"
                      label={t(
                        GENERATED_DOCUMENTS_PAGE.TO_DATE_LABEL.key,
                        GENERATED_DOCUMENTS_PAGE.TO_DATE_LABEL.value,
                      )}
                      placeholder={t(
                        GENERATED_DOCUMENTS_PAGE.TO_DATE_PLACEHOLDER.key,
                        GENERATED_DOCUMENTS_PAGE.TO_DATE_PLACEHOLDER.value,
                      )}
                      minDate={disabledDate.tillDisabledMinDate} //set the min date based on generated from date
                      maxDate={disabledDate.tillDisabledMaxDate}
                      className="dateTimePicker"
                      formatStyle="large"
                      size="small"
                      onChange={handleTillDateTimePicker}
                      hour24
                      value={startAndEndDate.endDate}
                    />
                  )}
                </div>
                {(environment === '' || environment === undefined) &&
                  selectedTeamsName.length === 0 &&
                  selectedTemplatesName.length === 0 &&
                  !startAndEndDate.startDate &&
                  !startAndEndDate.endDate ? (
                  <></>
                ) : (environment === '' || environment === undefined) &&
                  selectedTeamsName.length === 0 &&
                  selectedTemplatesName.length === 0 &&
                  (startAndEndDate.startDate || startAndEndDate.endDate) ? (
                  <ClearDataButton style={{ margin: '0' }}>
                    <button
                      data-hover={t(
                        GENERATED_DOCUMENTS_PAGE.CLEAR_DATE_FILTER_BUTTON.key,
                        GENERATED_DOCUMENTS_PAGE.CLEAR_DATE_FILTER_BUTTON.value,
                      )}
                      onClick={clearDate}
                    >
                      <div>
                        {t(
                          GENERATED_DOCUMENTS_PAGE.CLEAR_DATE_FILTER_BUTTON.key,
                          GENERATED_DOCUMENTS_PAGE.CLEAR_DATE_FILTER_BUTTON.value,
                        )}
                      </div>
                    </button>
                  </ClearDataButton>
                ) : environment !== '' ||
                  selectedTeamsName.length > 0 ||
                  selectedTemplatesName.length > 0 ||
                  startAndEndDate.startDate ||
                  startAndEndDate.endDate || channel || fileType ? (
                  <ClearDataButton style={{ margin: '0' }}>
                    <button
                      data-hover={t(
                        GENERATED_DOCUMENTS_PAGE.CLEAR_ALL_FILTER_BUTTON.key,
                        GENERATED_DOCUMENTS_PAGE.CLEAR_ALL_FILTER_BUTTON.value,
                      ).toUpperCase()}
                      onClick={clearAllFilters}
                    >
                      <div>
                        {t(
                          GENERATED_DOCUMENTS_PAGE.CLEAR_ALL_FILTER_BUTTON.key,
                          GENERATED_DOCUMENTS_PAGE.CLEAR_ALL_FILTER_BUTTON.value,
                        ).toUpperCase()}
                      </div>
                    </button>
                  </ClearDataButton>
                ) : (
                  <></>
                )}
                <div className="actions-container">
                  <SearchButton style={{ margin: '0' }}>
                    <button
                      data-hover={t(
                        GENERATED_DOCUMENTS_PAGE.SEARCH_BUTTON_LABEL.key,
                        GENERATED_DOCUMENTS_PAGE.SEARCH_BUTTON_LABEL.value,
                      ).toUpperCase()}
                      onClick={() => setFetchParameterDataObjController(true)}
                    >
                      <div>
                        {t(
                          GENERATED_DOCUMENTS_PAGE.SEARCH_BUTTON_LABEL.key,
                          GENERATED_DOCUMENTS_PAGE.SEARCH_BUTTON_LABEL.value,
                        ).toUpperCase()}
                      </div>
                    </button>
                  </SearchButton>
                </div>
              </Filters>
              {/* Table */}
              <DocumentTable>
                <div className="table_filter-info">
                  {generatedFiles.length > 1 || totalSearchedRecords > 1 ? (
                    <>
                      <div className="selected_documents">
                        <span className="title">
                          {t(
                            GENERATED_DOCUMENTS_PAGE.SELECTED_DOCUMNETS_COUNT_TITLE.key,
                            GENERATED_DOCUMENTS_PAGE.SELECTED_DOCUMNETS_COUNT_TITLE.value,
                          )}
                        </span>
                        <span className="value">{selectedDocuments.checkedListLength}</span>
                      </div>
                      {/* Delete all selected action */}
                      {selectedDocuments.checkAll && (
                        <div className="delete_selected-button" onClick={openConfirmationModal}>
                          {t(
                            GENERATED_DOCUMENTS_PAGE.DELETE_SELECTED_DOCUMNETS_ACTION.key,
                            GENERATED_DOCUMENTS_PAGE.DELETE_SELECTED_DOCUMNETS_ACTION.value,
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="search_results">
                    <span className="title">
                      {t(
                        GENERATED_DOCUMENTS_PAGE.SEARCHED_DOCUMNETS_COUNT_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.SEARCHED_DOCUMNETS_COUNT_TITLE.value,
                      )}
                    </span>
                    <span className="value">
                      <strong>{totalSearchedRecords}</strong>
                    </span>
                  </div>
                </div>
                <div>
                  <Table
                    className="documentsTable"
                    dataSource={tableLoader ? [] : generatedFiles}
                    rowKey={record => record.id}
                    onRow={(record, rowIndex) => ({
                      id: record.templateId,
                    })}
                    onChange={page => {
                      setPageChanged(true);
                      setCurrentPage(page.current);
                      setPagination(prev => ({ ...prev, current: page.current }));
                    }}
                    pagination={pagination}
                    loading={tableLoader}
                    scroll={{ y: 370 }}
                    scrollToFirstRowOnChange={true}
                  >
                    {(generatedFiles.length > 1 || totalSearchedRecords > 1) && (
                      <Column
                        className="selectAllCheckbox"
                        title={
                          <Checkbox
                            indeterminate={selectedDocuments.indeterminate}
                            onChange={onSelectAll}
                            checked={selectedDocuments.checkAll}
                          >
                            {t(
                              GENERATED_DOCUMENTS_PAGE.SELECT_ALL_DOCUMETS_CHECKBOX.key,
                              GENERATED_DOCUMENTS_PAGE.SELECT_ALL_DOCUMETS_CHECKBOX.value,
                            )}
                          </Checkbox>
                        }
                        dataIndex="documentSelected"
                        key="documentSelected"
                        render={() => (
                          <>{!!selectedDocuments.checkAll ? <Icon type="check" /> : ' '}</>
                        )}
                      />
                    )}
                    <Column
                      className="documentsNameColumn"
                      title={t(
                        GENERATED_DOCUMENTS_PAGE.DOCUMENT_NAME_COLUMN_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.DOCUMENT_NAME_COLUMN_TITLE.value,
                      )}
                      dataIndex="documentName"
                      key="documentName"
                    />
                    <Column
                      className="environmentColumn"
                      title={t(
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_COLUMN_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_COLUMN_TITLE.value,
                      )}
                      dataIndex="environment"
                      key="environment"
                      render={(text, record) => (
                        <>
                          {record.environment === 'sandbox'
                            ? t(
                              GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_COLUMN_TESTING_OPTION.key,
                              GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_COLUMN_TESTING_OPTION.value,
                            )
                            : t(
                              GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_COLUMN_PUBLISHED_OPTION.key,
                              GENERATED_DOCUMENTS_PAGE.ENVIRONMENT_COLUMN_PUBLISHED_OPTION.value,
                            )}
                        </>
                      )}
                    />
                    <Column
                      className="teamsNameColumn"
                      title={t(
                        GENERATED_DOCUMENTS_PAGE.TEAM_COLUMN_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.TEAM_COLUMN_TITLE.value,
                      )}
                      dataIndex="teamName"
                      key="teamName"
                    />
                    <Column
                      className="actionsColumn"
                      title={t(
                        GENERATED_DOCUMENTS_PAGE.ACTION_COLUMN_TITLE.key,
                        GENERATED_DOCUMENTS_PAGE.ACTION_COLUMN_TITLE.value,
                      )}
                      key="action"
                      render={(text, record) => (
                        <span>
                          <a href={process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_TRANSACTIONS_SYSTEM + record.encryptedLink} target="_blank">
                            {t(
                              GENERATED_DOCUMENTS_PAGE.VIEW_DOCUMENT_ACTION.key,
                              GENERATED_DOCUMENTS_PAGE.VIEW_DOCUMENT_ACTION.value,
                            )}
                          </a>
                          {!selectedDocuments.checkAll && (
                            <button
                              id={record.id}
                              className="delete-btn"
                              onClick={openConfirmationModal}
                            >
                              {t(
                                GENERATED_DOCUMENTS_PAGE.DELETE_DOCUMENT_ACTION.key,
                                GENERATED_DOCUMENTS_PAGE.DELETE_DOCUMENT_ACTION.value,
                              )}
                            </button>
                          )}
                        </span>
                      )}
                    />
                  </Table>
                </div>
              </DocumentTable>
            </ScrollContainer>
          </Container>
          <ConfirmationModal
            visibility={visible}
            onCancel={() => {
              setVisible(false);
              setIsSingleDocumentDeletion([]);
            }}
            onConfirm={deleteDocuments}
            confirmationText={
              isSingleDocumentDeletion.length > 0
                ? t(
                  `${CONFIRM}:${CONFIRMATION_MODAL.CONFIRMATION_MODAL_FIRST_TEXT.key}`,
                  CONFIRMATION_MODAL.CONFIRMATION_MODAL_FIRST_TEXT.value,
                )
                : t(
                  `${CONFIRM}:${CONFIRMATION_MODAL.CONFIRMATION_MODAL_SECOND_TEXT.key}`,
                  CONFIRMATION_MODAL.CONFIRMATION_MODAL_SECOND_TEXT.value,
                ) +
                ' ' +
                selectedDocuments.checkedListLength +
                ' ' +
                t(
                  `${CONFIRM}:${CONFIRMATION_MODAL.CONFIRMATION_MODAL_THIRD_TEXT.key}`,
                  CONFIRMATION_MODAL.CONFIRMATION_MODAL_THIRD_TEXT.value,
                )
            }
            confirmButtonText={t(
              `${CONFIRM}:${CONFIRMATION_MODAL.CONFIRMATION_MODAL_DELETE_BUTTON.key}`,
              CONFIRMATION_MODAL.CONFIRMATION_MODAL_DELETE_BUTTON.value,
            )}
            isLoading={isLoading}
          />
        </Main>
      </GeneratedDocumentsWrapper>
    </>
  );
}

export default withTranslation(NAMESPACES)(GeneratedDocuments);